import { useEffect, useMemo } from 'react'
import { LayoutPage } from '@/components/layout/page'
import { NoAccessError } from '@/lib/errors'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { hasProjectLevelRole } from '@/lib/rbac'
import { CreateLoadBalancerFallback } from '@/routes/load-balancers/create-load-balancer/fallback'
import { CreateLoadBalancerForm } from '@/routes/load-balancers/create-load-balancer/form'

export const CreateLoadBalancerPage = () => {
  const { idCompany } = useIdCompany()
  const { rbac, rolesInCompany } = useRBAC()

  const hasCreateAccess = useMemo(
    () => rbac.company(idCompany).loadBalancers.create.can(),
    [rbac, idCompany]
  )
  const hasProjectAccess = useMemo(
    () => hasProjectLevelRole(rolesInCompany),
    [rolesInCompany]
  )

  useEffect(() => {
    if (!hasCreateAccess && !hasProjectAccess) {
      throw new NoAccessError()
    }
  }, [hasCreateAccess, hasProjectAccess])

  return (
    <LayoutPage
      browserTitle="Create load balancer"
      fallback={<CreateLoadBalancerFallback />}
    >
      <CreateLoadBalancerForm />
    </LayoutPage>
  )
}
